module.exports = __webpack_public_path__ + "static/media/Pin_Job_KeyReplacement_Large.9d7763a6.svg";